import React from "react";

import Box from "@mui/material/Box";

import InfoBox from "components/InfoBox";

import { SubscriptionResponseDto } from "api";

import dayjs from "dayjs";

interface SubscriptionInfoBoxProps {
  currentSubs: SubscriptionResponseDto;
}

enum SubscriptionStatus {
  Trial,
  Free,
  Active,
  CanceledActive,
  Expired,
  Unknown,
}

const getSubscriptionStatus = (
  subs: SubscriptionResponseDto
): SubscriptionStatus => {
  const { isTrial, paymentPlan, isCancelled, isExpired } = subs;

  if (isExpired) return SubscriptionStatus.Expired; // show nothing

  if (isTrial) return SubscriptionStatus.Trial; // trial active canceled
  if (paymentPlan?.paymentPlanId === 1) return SubscriptionStatus.Free; // free active not canceled

  if (isCancelled) return SubscriptionStatus.CanceledActive; // paid active canceled

  return SubscriptionStatus.Active;
};

const SubscriptionInfoBox: React.FC<SubscriptionInfoBoxProps> = (props) => {
  const { currentSubs } = props;

  const { paymentPlan, endDate } = currentSubs;

  const subsPrice = paymentPlan.price || 0;
  const endDateFormatted = dayjs(endDate).format("DD MMMM YYYY");

  const status = getSubscriptionStatus(currentSubs);

  const infoMap: Record<
    SubscriptionStatus,
    { title: string; content: string | null }
  > = {
    [SubscriptionStatus.Trial]: {
      title: "Інформація про передплату.",
      content: `Ознайомчий період користування діє до ${endDateFormatted} року.`,
    },
    [SubscriptionStatus.Free]: {
      title: "Інформація про передплату.",
      content: `Ви використовуєте Безкоштовний тариф. Якщо бажаєте отримати більше можливостей, оберіть один з платних тарифів.`,
    },
    [SubscriptionStatus.Active]: {
      title: "Інформація про наступне продовження.",
      content: `Ваш тариф ${paymentPlan?.name} буде автоматично продовжений ${endDateFormatted} року. З вас буде стягнуто оплату у розмірі ${subsPrice} грн.`,
    },
    [SubscriptionStatus.CanceledActive]: {
      title: "Інформація про передплату.",
      content: `Вашу передплату за тарифом ${paymentPlan?.name} скасовано. Оплачений період користування діє до ${endDateFormatted} року.`,
    },
    [SubscriptionStatus.Expired]: {
      title: "",
      content: null,
    },
    [SubscriptionStatus.Unknown]: {
      title: "",
      content: null,
    },
  };

  const { title, content } = infoMap[status];

  if (!content) {
    return null;
  }

  return (
    <Box sx={{ mb: 3, width: "100%" }}>
      <InfoBox
        dataTestId="subscription-info-box"
        title={title}
        content={content}
      />
    </Box>
  );
};

export default SubscriptionInfoBox;
